// extracted by mini-css-extract-plugin
module.exports = {"container":"SideNav_container__3HLld","logo":"SideNav_logo__2BWCV","appName":"SideNav_appName__1gA1k","item":"SideNav_item__oJlfs","active":"SideNav_active__2p5sp"};